export const STEPS_DESCRIPTIONS = [
    "Detalles del refuerzo",
    "Información, duración y ubicación", 
    "Vista previa y confirmación"
];
export const ENVIRONMENT_FILLING_TYPES = [
    { id: 1, name: "Predefinido" },
    { id: 2, name: "Libre" }
];